import React, { Component } from 'react';
import { hello } from './Hello';
class UnikeCover extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hi: ''
        }
    }
    componentDidMount() {
        document.title = 'Christian Cruz Godoy';
        var i = 0;
        setInterval(() => {
            if (document.querySelector('#language') != null)
                this.setState({ hi: `${hello[i++]}` })
            if (i === hello.length) i = 0;
        }, 600);
    }

    render() {


        return (
            <>
                <img alt='bio pic' className='mee' src={`https://res.cloudinary.com/da4ouilgr/image/upload/q_100,f_auto,w_${window.innerWidth < 1224 ? Math.round(window.innerWidth * 0.5) : Math.round(window.innerWidth * 0.9)}/v1609364855/designer_avatars/designer_avatar_5fecf5495b0440036be903a1_8197.jpg`} />

                <div className='landing-container'>
                    <div className='landing-top'>
                        <span id='language' className='landing-languages'>{this.state.hi}</span>,
                        <br />
                        <div className='iam'>
                            I'm Christian Cruz Godoy.<br />
                        </div>
                        <div className='roles'>
                            Physicist. Entrepreneur. Software Engineer. Designer. Artist.
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default UnikeCover;
